import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Statistic } from './statistic'
import type { UpsertStatisticDto } from './dto/upsert-statistic.dto'

export class StatisticsRepository extends BaseRepository<Statistic> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/' + 'statistics', token, cache)
    }

    async tick(key: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/statistics/tick/' + key + '?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // Canal público: sem token, companyId explícito. Usado nas páginas /public/*, onde quem está na
    // tela é o cliente final da empresa e não existe sessão. O backend só aceita as chaves da allowlist
    // (statistics-public-keys.ts na users-api) — por isso as chaves aqui sempre começam com `pub.`.
    async tickPublic(companyId: string, key: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/statistics/public/tick/' + key + '?companyId=' + companyId,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async upsert(dto: UpsertStatisticDto) {
        const { json, statusCode, message } = await this.request.post(
            this.config.userApiUrl + '/statistics/tick/' + '?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
